import React from 'react';
import { useTranslation } from 'react-i18next';
import FilterCheckedCheckBox from 'src/assets/images/FilterCheckedCheckBox.svg';
import FilterUncheckedCheckBox from 'src/assets/images/FilterUncheckedCheckBox.svg';
import {
    LineSeparator,
    FilterComponentSelector,
    FilterComponentLabels,
    FilterLabel,
    OrderStatusIcons,
    FilterCheckbox,
    CheckBox,
    DefaultIndicator,
} from './FilterItemsCheckBox.styled';
import { useSelector } from 'react-redux';

const FilterItemsCheckBox = ({
    children,
    filterItem,
    filterItemId,
    iconUrl,
    isAdmin,
    onCheckBoxChange,
    checkBoxName,
    isChecked,
    labelWidth,
    width,
    labelResponsiveWidth,
    isDefault,
    labelMbWidth,
    lastElement,
    orderType,
    fontSize,
    fontFamily,
    fontColor,
    isShare,
}) => {
    const { t } = useTranslation();
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    // const isCondensedView = useSelector(
    //     (state) => state.loginReducer.isCondensedView
    // );

    const filterItemName = filterItem?.toLowerCase();
    return (
        <>
            <FilterComponentSelector
                style={{
                    marginBottom: lastElement === filterItem ? '15px' : null,
                }}
            >
                <FilterComponentLabels
                    htmlFor={`${filterItemId}`}
                    leftPadding={'15px'}
                    labelResponsiveWidth={labelResponsiveWidth}
                >
                    {isAdmin ? (
                        <FilterCheckbox
                            type="checkbox"
                            id={`${filterItemId}`}
                            name={checkBoxName}
                            value={`${filterItemId}`}
                            onChange={(event) => {
                                onCheckBoxChange(event, filterItem);
                            }}
                            checked={isChecked}
                        />
                    ) : (
                        <FilterCheckbox
                            type="checkbox"
                            id={`${filterItemId}`}
                            name={checkBoxName}
                            value={`${filterItemId}`}
                            onChange={(event) => {
                                // handleCheckBoxChange(e);
                                //onCheckBoxChange(event, checkBoxName);
                                onCheckBoxChange(
                                    event,
                                    checkBoxName,
                                    !isChecked,
                                    filterItem,
                                    filterItemId
                                );
                            }}
                            checked={isChecked}
                            // checked={checked}
                        />
                    )}

                    <CheckBox
                        src={
                            isChecked
                                ? FilterCheckedCheckBox
                                : FilterUncheckedCheckBox
                        }
                        rightMargin={'10px'}

                    ></CheckBox>
                    {(() => {
                        if (iconUrl)
                            return (
                                <OrderStatusIcons
                                    src={iconUrl}
                                ></OrderStatusIcons>
                            );
                    })()}
                    <FilterLabel
                        color="#00000"
                        labelWidth={labelWidth}
                        labelMbWidth={labelMbWidth}
                        width={width}
                        fontSize={fontSize}
                        fontFamily={fontFamily}
                        fontColor={fontColor}
                    >
                        {children
                            ? children
                            : filterItem === 'All'
                            ? t('common.allLabel')
                            : orderType
                            ? filterItemName === 'mast'
                                ? filterItemName.toUpperCase()
                                : filterItemName?.charAt(0).toUpperCase() +
                                  filterItemName?.slice(1)
                            : filterItem}
                    </FilterLabel>
                    {isDefault ? (
                        <DefaultIndicator width={isLanguageChanged && '63px'}>
                            {t(
                                'scheduleSurgery.Shipping.TissueServices.default'
                            )}
                        </DefaultIndicator>
                    ) : null}
                </FilterComponentLabels>

                <br />
            </FilterComponentSelector>
            {lastElement === filterItem || isShare ? null : <LineSeparator />}
        </>
    );
};

export default FilterItemsCheckBox;
